var aclh_module_popup = (function (aclh_module_popup) {
    aclh_module_popup.init = function(){


      $('#aclh-wrapper').on('click', 'a[data-aclh-popup]', function(event) {
        event.preventDefault();
        // // detect if dragged, cancel click.
        // var distX = Math.abs(event.clientX-mouseX);
        // var distY = Math.abs(event.clientY-mouseY);
        // var dist = Math.max(distX,distY);
        // // console.log(dist);
        // if(dist > 2) return false;

        // event.preventDefault();
        // var trend = $(this).attr('data-ltr6-trend-popup-slug');
        // var trendNane = $(this).attr('data-trend-name');
        // console.log(trend);
        // populatePopup(trend);
        $.featherlight('#aclh-popup',{
          namespace: 'aclh-featherlight',
          variant: 'chromeless',
        });

      });



    };
    return aclh_module_popup;
}(aclh_module_popup || {}));